import _ from 'lodash';

const removeTags = (str: string) => _.replace(str, /(<([^>]+)>)/ig, '');

export default removeTags;
